export default {
    userBaseData: 'Daten',
    userActivities: 'Historie',
    userCommunications: 'Kommunikation'
}
